import React from 'react';
import styled from 'styled-components';
import { cssColorValue, KeyboardDetectionProvider, makeColorSetClass, screenMdMin, screenSmMax, screenXxsMax, cssSpacing, } from '@spotify-internal/encore-web';
import { Carousel } from './Carousel/Carousel';
import { ImageAspectBox21x9, ContentfulImage, SectionHeader, } from '../../ui';
import { ColorSetWrapper } from '../../ui/Colors/Colors';
import { MAX_CONTENT_SCREEN_WIDTH, MAX_CONTENT_WIDTH, } from '../../ui/Components/Grid';
const Top = styled.div `
  background-color: ${cssColorValue('backgroundBase')};
  padding: ${cssSpacing('looser-3')} ${cssSpacing('looser-3')};
  padding-bottom: 0px;

  // tablet and below
  @media (max-width: ${screenSmMax}) {
    padding: ${cssSpacing('looser-2')};
    padding-bottom: 0px;
  }

  // max content width of 1524x
  @media (min-width: ${MAX_CONTENT_SCREEN_WIDTH}) {
    padding-inline: calc((100% - ${MAX_CONTENT_WIDTH}) / 2);
  }

  // mobile and below
  @media (max-width: ${screenXxsMax}) {
    padding: ${cssSpacing('base')};
    padding-top: ${cssSpacing('looser-2')};
    padding-bottom: 0px;
  }
`;
const Bottom = styled.div `
  color: ${cssColorValue('textBase')};
  background-color: ${cssColorValue('backgroundBase')};
  display: grid;
  grid-template-columns: 1fr 1fr;

  // desktop tweak top padding if no top image
  @media (min-width: ${screenMdMin}) {
    padding: ${cssSpacing('looser-3')} ${cssSpacing('looser-3')};
    padding-top: ${({ hasTop }) => !hasTop ? cssSpacing('looser-3') : cssSpacing('looser-2')};
  }

  // max content width of 1524px
  @media (min-width: ${MAX_CONTENT_SCREEN_WIDTH}) {
    padding-inline: calc((100% - ${MAX_CONTENT_WIDTH}) / 2);
  }

  // tablet and below
  @media (max-width: ${screenSmMax}) {
    grid-template-columns: 1fr;
    padding: ${cssSpacing('looser-2')};
    padding-top: ${({ hasTop }) => !hasTop ? cssSpacing('looser-2') : cssSpacing('looser-2')};
  }

  // mobile and below
  @media (max-width: ${screenXxsMax}) {
    padding: ${cssSpacing('base')};
    padding-top: ${({ hasTop }) => !hasTop ? cssSpacing('looser-2') : cssSpacing('looser-2')};
  }
`;
const Half = styled.div `
  @media (min-width: ${screenMdMin}) {
    max-width: 82%;
  }
  @media (max-width: ${screenSmMax}) {
    padding-bottom: ${cssSpacing('looser-3')};
  }
`;
const ImageContainer = styled(ImageAspectBox21x9) ``;
export const MiniCarouselNarrativeModule = React.forwardRef((props, ref) => {
    var _a, _b;
    const useColors = ((_a = props.colors) === null || _a === void 0 ? void 0 : _a.backgroundColor) && ((_b = props.colors) === null || _b === void 0 ? void 0 : _b.textColor);
    return (React.createElement(KeyboardDetectionProvider, null,
        React.createElement(ColorSetWrapper, { colors: props.colors, transparent: props.transparent },
            React.createElement("div", { ref: ref, className: !useColors
                    ? makeColorSetClass(props.themeName === 'light' ? 'base' : 'invertedDark')
                    : '' },
                props.image && (React.createElement(Top, null,
                    React.createElement(ImageContainer, null,
                        React.createElement(ContentfulImage, { asset: props.image })))),
                React.createElement(Bottom, { hasTop: !!props.image },
                    React.createElement(Half, null,
                        React.createElement(SectionHeader, { eyebrow: props.supertext, heading: props.headline, subhead: props.subheading, body: props.body })),
                    React.createElement(Carousel, { slides: props.miniCarouselSlides, locale: props.locale || 'en-US' }))))));
});
